<template>
  <div class="activity-warp">
    <div class="activity-head">
      <img class="backicon" src="../../assets/imgs/close.png" @click="onBack">
      <div class="activity-title">网络检测</div>
    </div>
    <div style="margin: 10px">
      <div class="netProgress">
        <div class="posititionView">
          <div class="progressBarView">
            <progressBar ref="progressBarView"></progressBar>
          </div>
          <div class="vanCircleText">
            <div class="title">{{checkStatus}}</div>
            <div class="number">
              <span class="num">{{ progress }}</span>%
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="cardView">
      <div class="cardViewBg">
        <div class="card">
          <div class="" style="background: #1E4DDC"></div>
          <div class="from">
            <div class="item">
              <div class="left">
                <div class="type">网络状况:</div>
                <div class="status">{{deviceSignStatus}}</div>
              </div>
            </div>
            <div class="item">
              <div class="left">
                <div class="type">可用流量:</div>
                <div class="status error">{{remainValue}}GB</div>
              </div>
              <div class="right">
                <div class="btnView">
                </div>
              </div>
            </div>

            <div class="item">
              <div class="left">
                <div class="type">套餐有效期:</div>
                <div class="status" >{{invalidDate}}</div>
              </div>
              <div class="right">
                <div class="btnView">
                </div>
              </div>
            </div>
            <div class="item">
              <div class="left">
                <div class="type">设备状态:</div>
                <div class="status error" >{{cardOneRealStatus}}</div>
              </div>
            </div>
          </div>
          <div class="hint">
            <div class="tips">综合说明:</div>
            <div class="msg"> 如果已无流量、套餐已到期或已停机，请进行流量套餐充值。</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ORDER_LIST } from '../../apis/user'
import { mapState } from "vuex";
import progressBar from '../../components/progress/progress.vue'
import { MIFI_DEVICE_INFO, MIFI_DEVICE_PKG } from "@/apis/cabinet";
export default {
  components: {
    progressBar
  },
  computed: {
    ...mapState(['mifisn'])
  },
  data () {
    return {
      progress: 100,
      cardOneRealStatus: '可用',
      deviceSignStatus: '差',
      remainValue: 0,
      pkgUsedCnt: 0,
      pkgValue: 0,
      invalidDate: null,
      time: 0,
      checkStatus: '检查中'
    }
  },
  methods: {
    onBack () {
      this.$router.go(-1)
    },
    backHome() {
      this.$router.push('/')
    },
    deviceInfoById() {
      this.$post(
        MIFI_DEVICE_INFO, {
          devId: this.mifisn
        }, (resp) => {
          if (resp.data) {
            this.deviceSignStatus = '差'
            if (resp.data.data.online === 0) {
              this.cardOneRealStatus = '离线'
            } else if (resp.data.data.online === 1) {
              this.deviceSignStatus = '良好'
              this.cardOneRealStatus = '在线'
            } else if (resp.data.data.online === 3) {
              this.cardOneRealStatus = '已拿卡'
            } else if (resp.data.data.online === 4) {
              this.cardOneRealStatus = '拿卡失败'
            } else if (resp.data.data.online === 5) {
              this.cardOneRealStatus = '正在拨号'
            } else if (resp.data.data.online === 6) {
              this.cardOneRealStatus = '下线'
            } else if (resp.data.data.online === 6) {
              this.cardOneRealStatus = '本地卡在线'
            }
          }
        },
        (error) => {
          this.$loading(false)
          this.$toast(error)
        }
      )
    },
    initProgressBar() {
      var interval = setInterval(() => {
        this.time++
        this.$refs.progressBarView.loadCircleProgress(5)
        if (this.time === 2) {
          this.$refs.progressBarView.loadCircleProgress(25)
          this.progress = 25
        } else if (this.time === 4) {
          this.$refs.progressBarView.loadCircleProgress(50)
          this.progress = 50
        } else if (this.time === 6) {
          this.$refs.progressBarView.loadCircleProgress(75)
          this.progress = 75
        } else if (this.time === 8) {
          this.$refs.progressBarView.loadCircleProgress(100)
          this.progress = 100
          this.checkStatus = "检测完成"
          clearInterval(interval)
        }
      }, 300)
    },
    loadPkg() {
      this.$post(
        MIFI_DEVICE_PKG, {
          devId: this.mifisn
        }, (resp) => {
          if (resp.data) {
            this.pkgUsedCnt = resp.data.pkgUsedCntT
            this.remainValue = resp.data.remainValueT
            this.pkgValue = resp.data.pkgValueT
            this.percent = (resp.data.pkgUsedCntT / resp.data.pkgValueT) * 100
            this.invalidDate = resp.data.invalidDate
          }
        },
        (error) => {
          this.$loading(false)
          this.$toast(error)
        }
      )
    }
  },
  created () {
    this.deviceInfoById()
    this.loadPkg()
    this.initProgressBar()
  },
  mounted() {
    this.$refs.progressBarView.loadCircleProgress(10)
  }
}
</script>

<style lang="less">
.activity-warp {
  height: 100vh;
  // background: linear-gradient(#00AB46, #1A2229);
  background: #F4F4F4;
  .activity-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;

    .backicon {
      width: 50px;
    }
    .activity-title {
      text-align: center;
      width: 100%;
      font-family: Montserrat, Montserrat;
      font-weight: bold;
      font-size: 36px;
      color: #1A2229;
    }
  }
}
.netProgress {
  width: 3.6rem;
  height: 2rem;
  position: fixed;
  left: 50%;
  margin-left: -1.8rem;

  .posititionView {
    position: relative;
    width: 100%;
    height: 100%;

    .progressBarView {
      width: 100%;
      height: 100%;
      position: absolute;
      z-index: 1;

    }
    .vanCircleText {
      position: absolute;
      z-index: 10;
      text-align: center;
      color: #FFFFFF;
      width: 3.6rem;
      height: 1.92rem;
      .title {
        font-size: 0.24rem;
        padding-top: 0.7rem;
        margin-bottom: 0.1rem;
      }
      .number {
        font-size: 0.28rem;

        .num {
          font-size: 0.7rem;
          font-weight: bold;
        }
      }
    }
  }
}
.cardView {
  position: fixed;
  top: 4rem;
  left: 0rem;
  right: 0rem;
  bottom: 0;
  background: #F2F2F2;
  border-top-left-radius: 0.2rem;
  border-top-right-radius: 0.2rem;
  .cardViewBg {
    width: 100%;
    height: 100%;
    position: relative;
    .card {
      position: absolute;
      top: 0.4rem;
      left: 0.35rem;
      right: 0.35rem;
      bottom: 0;
      padding: 0.24rem 0.3rem 0.3rem;
      background: #FFFFFF;
      border-top-left-radius: 0.2rem;
      border-top-right-radius: 0.2rem;
      .from {
        margin-bottom: 0.3rem;
        .item {
          display: flex;
          height: 1.06rem;
          border-bottom: 0.01rem solid #CCCCCC;
          .left {
            padding-left: 0.3rem;
            flex: 1;
            height: 1.06rem;
            .type {
              font-weight: bold;
              font-size: 0.28rem;
              color: #333333;
              line-height: 1.06rem;
              float: left;
            }
            .status {
              font-weight: bold;
              font-size: 0.26rem;
              color: #339933;
              line-height: 1.06rem;
              float: left;
              margin-left: 0.3rem;
            }
            .error {
              color: #990000;
            }
            .btnView {
              float: left;
              margin-left: 0.3rem;
              width: 1.26rem;
              height: 1.06rem;
              display: flex;
              justify-content: center;
              align-items: center;
              .btn {
                width: 1.26rem;
                height: 0.48rem;
                background: rgba(236, 244, 254, 0.6);
                border-radius: 0.24rem;
                border: 0.01rem solid #387FE9;
                color: #387FE9;
                font-size: 0.26rem;
                text-align: center;
                line-height: 0.48rem;
              }
            }
          }
          .right {
            float: right;
            width: 0.68rem;
            .btnView {
              width: 0.68rem;
              height: 1.06rem;
              display: flex;
              justify-content: center;
              align-items: center;
              .btn {
                background: #FE8741;
                border-radius: 0.2rem 0.2rem 0.2rem 0;
                width: 0.68rem;
                height: 0.48rem;
                line-height: 0.48rem;
                text-align: center;
                font-size: 0.26rem;
                color: #FFFFFF;
              }
            }
          }
        }
      }
      .hint {
        padding: 0.3rem 0.3rem 0;
        height: 1.7rem;
        background: #FFFCF7;
        border-radius: 0.2rem;
        .tips {
          color: #333333;
          font-weight: bold;
          font-size: 0.24rem;
          line-height: 0.4rem;
        }
        .msg {
          color: #666666;
          font-size: 0.24rem;
          line-height: 0.4rem;
        }
      }
    }
  }
}
</style>
